
import React, { useEffect, useState } from 'react';
import CarsItem from '../CarsItem/CarsItem';
import NotDeleteCar from '../NotDeletCar/NotDeleteCar';
import './Cars.css';


const Cars = () => {
     const [cars, setCars] = useState([])
     const [add, setAdd] = useState([])




     useEffect(() => {
          fetch('https://secure-springs-71035.herokuapp.com/service')
               .then(res => res.json())
               .then(data => setCars(data))

     }, [])


     const handleAdd = (car) => {
          const newAdd = [...cars, car];

     }




     return (
          <div className='my-5 py-5'>
               <h3 className='text-center pb-3 fw-bolder text-primary'>TAKE THE CAR OF YOUR CHOICE</h3>

               <div className='cars mt-4 container'>

                    {
                         cars.map(car => <CarsItem
                              key={car._id}
                              car={car}
                         >
                         </CarsItem>).slice(0, 6)
                    }
               </div>
          </div>

     );
};

export default Cars;